import React from "react";
import { arrayOf, elementType, shape, string } from "prop-types";
import Link from "@insightfulscience/atomic-react/Link";
import CardBlock from "@insightfulscience/atomic-react/CardBlock";
import { CardBlockCol, CardBlockRow } from "@insightfulscience/atomic-react/CardBlock/Grid";
import getContentProps from "../../utils/getContentProps";
import videoDto from "../../dtos/video.dto";

const RecommendedVideos = ({ TagItem = CardBlock, items, ...props }) => {
	return (
		<CardBlockRow {...props}>
			{items.map(item => {
				const contentProps = getContentProps(item.sys.contentType.sys.id);
				const { id, title, thumbnail, metaDescription, slug } = videoDto(item);
				return (
					<CardBlockCol key={id}>
						<TagItem
							LinkComponent={Link}
							cardType={contentProps?.typePlaceholder}
							titleText={title}
							imgSrc={thumbnail}
							descriptionText={metaDescription}
							href={`${contentProps?.alias}/${slug}`}
							linkButtonText={contentProps.linkPlaceholder}
						/>
					</CardBlockCol>
				);
			})}
		</CardBlockRow>
	);
};

RecommendedVideos.propTypes = {
	TagItem: elementType,
	items: arrayOf(
		shape({
			id: string.isRequired,
			title: string.isRequired,
			metaDescription: string,
			slug: string,
		}),
	),
};

export default RecommendedVideos;
